import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: 'input[appDigitsOnly]',
})
export class DigitsOnlyDirective {
  @Input('appDigitsOnly') enabled = true;

  @HostListener('input', ['$event.target'])
  onInput(input: HTMLInputElement): void {
    if (!this.enabled) {
      return;
    }

    const digits = input.value.replaceAll(/\D/g, '');
    if (input.value !== digits) {
      input.value = digits;
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }
}
